export const GET_KYC_INFO_REQUEST = "GET_KYC_INFO_REQUEST";
export const GET_KYC_INFO_SUCCESS = "GET_KYC_INFO_SUCCESS";
export const GET_KYC_INFO_FAILURE = "GET_KYC_INFO_FAILURE";
export const GET_KYC_INFO_RESET = "GET_KYC_INFO_RESET";
export const getKycInfoRequest = (payload) => ({
    type: GET_KYC_INFO_REQUEST,
    payload,
});
export const getKycInfoSuccess = (payload) => ({
    type: GET_KYC_INFO_SUCCESS,
    payload,
});
export const getKycInfoFailure = (payload) => ({
    type: GET_KYC_INFO_FAILURE,
    payload,
});
export const getKycInfoReset = () => ({
    type: GET_KYC_INFO_RESET,
});
